/* Central registry of the AI characters — used by the home gallery and the share page. */
import { Feather, Trees, Eye, Sprout, Crown, Clover, Moon, ScrollText, Zap, Sun, Landmark, Heart, Sunrise, Flame, BookOpen, Shield, Globe } from "lucide-react";
import { ELEMENTS } from "@/lib/elements";

export const CHARACTER_GROUPS = [
  { id: "celtes", fr: "Voix celtiques", en: "Celtic voices" },
  { id: "grecs", fr: "Voix grecques", en: "Greek voices" },
  { id: "cosmos", fr: "Voix du cosmos & des anges", en: "Cosmic & angelic voices" },
  { id: "elements", fr: "Voix des éléments · Guantraí", en: "Voices of the elements · Guantraí" },
];

export const CHARACTERS = [
  { id: "barde", group: "celtes", name: "Le Barde", href: "/barde", Icon: Feather, accent: "#f5d572",
    fr: "Conteur taquin au coin du feu", en: "Teasing storyteller by the fire" },
  { id: "druide", group: "celtes", name: "Le Druide", href: "/druide", Icon: Trees, accent: "#a67bff",
    fr: "Sage du Nemeton, tuteur érudit", en: "Sage of the Nemeton, erudite tutor" },
  { id: "vate", group: "celtes", name: "Le Vate", href: "/vate", Icon: Eye, accent: "#7dd3c0",
    fr: "Guérisseur des émotions", en: "Healer of emotions" },
  { id: "gaia", group: "celtes", name: "Gaïa", href: "/gaia", Icon: Sprout, accent: "#7bc47f",
    fr: "La Terre-Mère qui ramène au corps", en: "Mother Earth, back to the body" },
  { id: "dagda", group: "celtes", name: "Le Dagda", href: "/dagda", Icon: Crown, accent: "#c48a3f",
    fr: "Père des dieux, maître de la harpe", en: "Father-god, master of the harp" },
  { id: "farfadet", group: "celtes", name: "Le Farfadet", href: "/farfadet", Icon: Clover, accent: "#c8f76c",
    fr: "Lutin farceur et blagues du jour", en: "Prankster sprite, daily jokes" },
  { id: "korrigan", group: "celtes", name: "Le Korrigan", href: "/korrigan", Icon: Moon, accent: "#e07a4f",
    fr: "Malice des landes bretonnes", en: "Mischief of the Breton moors" },
  { id: "grammarien", group: "celtes", name: "Le Grammarien", href: "/grammarien", Icon: ScrollText, accent: "#e6d9a2",
    fr: "Maître des mots d'Iona", en: "Master of words from Iona" },
  { id: "zeus", group: "grecs", name: "Zeus", href: "/zeus", Icon: Zap, accent: "#ffd84a",
    fr: "Roi foudroyant de l'Olympe", en: "Thundering King of Olympus" },
  { id: "apollon", group: "grecs", name: "Apollon", href: "/apollon", Icon: Sun, accent: "#ff9a4a",
    fr: "Ami solaire qui éclaire sans diriger", en: "Solar friend who enlightens without directing" },
  { id: "delphe", group: "grecs", name: "Oracle de Delphes", href: "/oracle-delphe", Icon: Landmark, accent: "#ffcf5a",
    fr: "L'éclatante vérité d'Apollon", en: "Apollo's dazzling truth" },
  { id: "eros", group: "grecs", name: "Éros", href: "/eros", Icon: Heart, accent: "#ff6b9d",
    fr: "Éducateur des quatre amours", en: "Teacher of the four loves" },
  { id: "phanes", group: "grecs", name: "Phanès", href: "/phanes", Icon: Sunrise, accent: "#ffe9a8",
    fr: "Lumière de la création primordiale", en: "Light of primordial creation" },
  { id: "ahura", group: "cosmos", name: "Ahura Mazda", href: "/ahura", Icon: Flame, accent: "#f5b800",
    fr: "Sagesse du feu zoroastrien", en: "Zoroastrian fire wisdom" },
  { id: "urantia", group: "cosmos", name: "Livre d'Urantia", href: "/urantia", Icon: BookOpen, accent: "#64a0ff",
    fr: "Enseignant cosmique", en: "Cosmic teacher" },
  { id: "anges", group: "cosmos", name: "Anges Guides", href: "/anges-guides", Icon: Shield, accent: "#8fb3ff",
    fr: "Cinq archanges, cinq lumières", en: "Five archangels, five lights" },
  { id: "polyglotte", group: "cosmos", name: "Le Polyglotte", href: "/polyglotte", Icon: Globe, accent: "#9fe2bf",
    fr: "30 langues, en douceur", en: "30 languages, gently" },
  ...ELEMENTS.map((e) => ({ id: e.persona, group: "elements", name: e.fr.name, href: e.href, Icon: e.Icon,
    accent: e.accent, fr: e.fr.line, en: e.en.line })),
];
